import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BookingStaffService, BookingLocation, BookingSyncAssignment } from './booking-staff.service';

interface LocationRow {
  locationId: string;
  name: string;
  checked: boolean;
  title: string;
}

@Component({
  selector: 'app-booking-bulk-sync-dialog',
  templateUrl: './booking-bulk-sync-dialog.component.html',
  styleUrls: ['./booking-bulk-sync-dialog.component.css'],
  standalone: false
})
export class BookingBulkSyncDialogComponent implements OnInit {
  loading = true;
  saving = false;
  rows: LocationRow[] = [];

  readonly titleOptions = [
    { value: 'staff',   label: 'Empleado' },
    { value: 'manager', label: 'Responsable' }
  ];

  constructor(
    private dialogRef: MatDialogRef<BookingBulkSyncDialogComponent>,
    private bookingStaffService: BookingStaffService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.bookingStaffService.getSyncLocations().subscribe({
      next: (res) => {
        this.rows = res.locations.map((loc: BookingLocation) => ({
          locationId: loc.locationId,
          name: loc.name,
          checked: false,
          title: 'staff'
        }));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('Error al cargar las ubicaciones de Bookcit', 'Cerrar', { duration: 3000 });
      }
    });
  }

  save(): void {
    const assignments: BookingSyncAssignment[] = this.rows
      .filter(r => r.checked)
      .map(r => ({ locationId: r.locationId, title: r.title }));

    this.saving = true;
    this.bookingStaffService.bulkSync(assignments).subscribe({
      next: (res) => {
        this.saving = false;
        this.snackBar.open(`${res.synced} empleados sincronizados con Bookcit`, 'OK', { duration: 4000 });
        this.dialogRef.close(true);
      },
      error: () => {
        this.saving = false;
        this.snackBar.open('Error al sincronizar con Bookcit', 'Cerrar', { duration: 3000 });
      }
    });
  }

  cancel(): void { this.dialogRef.close(false); }
}
